import { render, staticRenderFns } from "./ForwardDocument.vue?vue&type=template&id=c33294ec&scoped=true&"
import script from "./ForwardDocument.vue?vue&type=script&lang=js&"
export * from "./ForwardDocument.vue?vue&type=script&lang=js&"
import style0 from "./ForwardDocument.vue?vue&type=style&index=0&id=c33294ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33294ec",
  null
  
)

export default component.exports